import { ChangeEvent } from "react"

const useOuterLengthsConfiguration = (
	outerLengths: number[],
	selectedOuterLength: number,
	onOuterLengthChange: (selectedOuterLength: number) => void,
) => {
	const outerLengthInputProps = {
		value: selectedOuterLength,
		onChange: (event: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
			const selectedOuterLength = Number(event.target.value)
			onOuterLengthChange(selectedOuterLength)
		},
	}

	return {
		outerLengthInputProps,
		availableOuterLengths: outerLengths,
	}
}

export default useOuterLengthsConfiguration
